<template>
  <div class="careering page-center">
    <div class="subhead-0">
      <CareeringSubheader />
    </div>
    <div class="roles padded-width">
      <a
        v-for="(role, index) in roles"
        :key="'role-' + index"
        :href="role.path"
        @click.prevent="transitionTo(role.path)"
        :class="['button', 'role-' + index]"
        >{{ role.name }}
      </a>
      <a
        :key="'role-' + roles.length"
        :class="['button', 'role-' + roles.length]"
        href="/careering/create-a-role"
        @click.prevent="transitionTo('/careering/create-a-role')"
      >
        <div class="shine">Create a Role</div>
      </a>
    </div>
  </div>
</template>

<script>
import CareeringSubheader from "./CareeringSubheader.vue";
import { Howl } from "howler";

export default {
  name: "Careering",
  components: {
    CareeringSubheader,
  },
  props: {},
  data() {
    return {
      isTransitioning: false,
      roles: [
        {
          name: "Backend Engineer",
          path: "/careering/backend-engineer",
        },
        {
          name: "iOS Engineer",
          path: "/careering/ios-engineer",
        },
      ],
      audio: null,
      // sound: new Howl({
      //   src: ["/sounds/blip-01.wav"],
      // }),
    };
  },
  watch: {},
  methods: {
    // handleClick(e) {
    //   e.preventDefault();
    //   this.sound.play();
    //   console.log(e.target);
    // },
    transitionTo(path) {
      const duration = 0;
      this.$store.commit("setTransitioning", true);

      // this.sound.play();
      // this.audio.play();

      setTimeout(() => {
        this.$router.push(path);
      }, duration);
    },
  },
  mounted() {
    this.audio = new Audio(require("../../public/sounds/train-blip-02.mp3"));
  },
  head() {
    return {
      title: "Roles at USB Club",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "Roles at USB Club",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "Career with us.",
        },
        {
          name: "description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "Roles at USB Club",
        },
      ],
    };
  },
};
</script>

<style scoped>
.careering {
  width: 100%;
  height: 100%;
}

.roles {
  grid-gap: 1.6rem;
  max-width: 27rem;
}

a.button {
  width: 100%;
  text-decoration: none;
}

.roles .button:nth-child(1) {
  --top-shadow-distance: 8px;
}

.roles .button:nth-child(2) {
  --top-shadow-distance: 6px;
}

.subhead-0 {
  width: 100%;
}

.careering.fade-leave-active .subhead-0,
.careering.fade-leave-active .role-0,
.careering.fade-leave-active .role-1,
.careering.fade-leave-active .role-2,
.careering.fade-leave-active .role-3,
.careering.fade-leave-active .role-4 {
  transition: all 250ms ease-in-out;
  opacity: 0;
  transform: translateY(16px);
}

.careering.fade-leave-active .subhead-0 {
  transition-delay: 125ms;
}

.careering.fade-leave-active .role-0 {
  transition-delay: 50ms;
}

.careering.fade-leave-active .role-1 {
  transition-delay: 25ms;
}
</style>
